export type SubscriptionType = "basic";
export type CurrencyString = "USD";
export type Period = "yearly";

export enum ExperimentOfferFlow  {
  original = "trialFirst",
  stripeCheckout = "stripeCheckout"
}

export type Trial = {
  days: number;
  stripeSessionCheckoutUrl?: string;
  paymentAfterTrial: {
    amount: number;
    currency: CurrencyString;
    period: Period;
  };
  stripeSetupIntent: {
    clientSecret: string;
  };
};

export type Payment = {
  amount: number;
  currency: CurrencyString;
  period: Period;
  stripeSessionCheckoutUrl?: string;
  stripePaymentIntent: {
    clientSecret: string;
  };
};

export type SubscriptionStatus = {
  subscription: {
    [key in SubscriptionType]: {
      hasSubscription: boolean;
      hasTrial: boolean;
      experimentOfferFlow: ExperimentOfferFlow;
    };
  };
};

export type PaymentInfo = {
  trial?: Trial;
  payment?: Payment;
};


export type PaymentData = {
  amount: number;
  period: PeriodType;
  currency: CurrencyString;
};

export type PeriodType = "yearly" | "monthly" | "weekly" | "daily";

export type PeriodTimeForms = {
  adjective: string;
  adverb: string;
  singular: string;
};

export type PeriodMapping = {
  [key in PeriodType]: PeriodTimeForms;
};

export enum ButtonVariant {
  primary = "primary",
  secondary = "secondary",
  transparent = "transparent",
}
